/* unplugin-vue-components disabled */import script from "./chooseKeyword.vue?vue&type=script&setup=true&lang=js"
export * from "./chooseKeyword.vue?vue&type=script&setup=true&lang=js"

import "./chooseKeyword.vue?vue&type=style&index=0&id=3acec782&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3acec782"]])

export default __exports__